module.exports = "https://ec-cstatic.akulaku.net/mall/growth-publish/_next/static/images/Msn-20c5e1a1ef83bbe0aa188ec2981295c0.png";